import { createSelector } from '@reduxjs/toolkit';

import { CARD_STATUS_BADGE_CONFIG } from '@shared/config';

export const selectIsLoadingUser = (state) => state.user.isLoadingUser;

export const selectAccountMembershipId = (state) => state.user.accountMembershipId;

export const selectUserFirstName = (state) => state.user.user.firstName;
export const selectUserLastName = (state) => state.user.user.lastName;
export const selectUserEmail = (state) => state.user.user.email;
export const selectUserPhone = (state) => state.user.user.phone;
export const selectUserBirthDate = (state) => state.user.user.birthDate;
export const selectUserStatus = (state) => state.user.user.status;
export const selectCompanyId = (state) => state.user.user.companyId;

export const selectCompanyUsers = (state) => state.user.user.companyUsers;

export const selectDebitCardId = (state) => state.user.user.debitCard?.id;

const selectRawDebitCards = (state) => state.user.user.debitCards;

// /v1/user lists every card of the account, cancelled and consent-pending ones included,
// so the page has to do the filtering. CARD_STATUS_BADGE_CONFIG is already the app's
// known-status whitelist (the company card list and useCardStatus both gate on it), which
// makes it the filter here too: a status the app cannot render a badge for is a card it
// cannot render at all. Memoized because filter() returns a fresh array on every call —
// an unmemoized selector would hand useSelector a new reference each time and re-render
// forever.
export const selectUsableDebitCards = createSelector([selectRawDebitCards], (debitCards) =>
	(debitCards ?? []).filter((card) => Boolean(CARD_STATUS_BADGE_CONFIG[card?.cardStatus])),
);

export const selectUserFullName = createSelector(
	[selectUserFirstName, selectUserLastName],
	(firstName, lastName) => {
		const normalizedFirstName = firstName || '';
		const normalizedLastName = lastName || '';
		const fullName = [normalizedFirstName, normalizedLastName].filter(Boolean).join(' ').trim();
		return {
			firstName: normalizedFirstName,
			lastName: normalizedLastName,
			fullName,
		};
	},
);
